import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function Home() {
    const { t } = useTranslation();
    return (_jsxs("section", { className: "hero", children: [_jsx("h1", { children: t('home.title') }), _jsx("p", { className: "lead", children: t('home.subtitle') }), _jsx(Link, { to: "/register", className: "btn btn-primary btn-lg", children: t('home.cta') })] }));
}
